import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";

export async function uploadGuardPhoto(file, jobId, stopId, guardId, photoType) {
  const ext = file.name?.split(".").pop() || "jpg";
  const path = `guard-photos/${jobId}/${stopId}/${guardId}_${photoType}_${Date.now()}.${ext}`;
  const storageRef = ref(storage, path);
  await uploadBytesResumable(storageRef, file);
  return getDownloadURL(storageRef);
}

export async function uploadProfilePhoto(file, userId) {
  const ext = file.name?.split(".").pop() || "jpg";
  const path = `profile-photos/${userId}_${Date.now()}.${ext}`;
  const storageRef = ref(storage, path);
  await uploadBytesResumable(storageRef, file);
  return getDownloadURL(storageRef);
}

export async function uploadTwicCard(file, userId) {
  const ext = file.name?.split(".").pop() || "jpg";
  const path = `twic-cards/${userId}_${Date.now()}.${ext}`;
  const storageRef = ref(storage, path);
  await uploadBytesResumable(storageRef, file);
  return getDownloadURL(storageRef);
}

// POD/AWB form scan (used when guard scans unexpected packages at airport)
export async function uploadPodScan(file, jobId, guardId) {
  const ext = file.name?.split(".").pop() || "jpg";
  const path = `pod-scans/${jobId}/${guardId}_${Date.now()}.${ext}`;
  const storageRef = ref(storage, path);
  await uploadBytesResumable(storageRef, file);
  return getDownloadURL(storageRef);
}

// Receipt photo for an expense line on a job — toll, parking, box truck
// rental, etc. Stored under expense-receipts/{jobId}/ so we can list/
// retrieve them per job. Per-expense association lives on the
// expenseItems[].receiptPhotoUrl field on the job doc.
export async function uploadExpenseReceipt(file, jobId, userId) {
  const ext = file.name?.split(".").pop() || "jpg";
  const path = `expense-receipts/${jobId}/${userId}_${Date.now()}.${ext}`;
  const storageRef = ref(storage, path);
  await uploadBytesResumable(storageRef, file);
  return getDownloadURL(storageRef);
}
